import { Module } from '@nestjs/common';
import { PrismaModule } from 'src/prisma/prisma.module';
import { FifoService } from './fifo.service';
import { LotesController } from './lotes.controller';
import { LotesService } from './lotes.service';

@Module({
  imports: [PrismaModule],
  controllers: [LotesController],
  providers: [LotesService, FifoService],
  exports: [LotesService, FifoService],
})
export class LotesModule {}
